import { useState, useCallback } from "react";

import userPermissionsService from "./user-permissions-service";

const getProgramId = (navigation) => {
  if (navigation) {
    if (navigation.area) {
      if (navigation.program) {
        return navigation.program?.id;
      }
      if (navigation.coordinator) {
        return navigation.coordinator?.id;
      }
      if (navigation.region) {
        return navigation.region?.id;
      }
      return navigation.area?.id;
    }
  }
  return 0;
};

const defaultService = new userPermissionsService();
const usePermissions = (service = defaultService) => {
  const [permissionData, setPermissionData] = useState({
    verified:[],
    requested:[]
  });

  const clear = useCallback(() => {
    setPermissionData({verified:[],requested:[]})
  },[]);
  const requestPermissions = useCallback((programId = 0, requestedPermissions = []) => {
    const loadPermissions = async (permissions) => {
      const loaded = await service.checkUserPermissions(programId,permissions);
      //because this part is async
      //we need to do the setter with the function just in case some other condition had applied to
      //this state data while this load was running.
      setPermissionData(current => {
        const result = {...current};
        //save the full set of permissions we are asking for in requested
        result.requested = [...result.requested,...permissions];
        //one of the permissions we checked came back in the affirmative so we need to update verified.
        if (loaded.length > 0) {
          result.verified = [...result.verified, ...loaded];
        }
        return result;
      })

    }

    setPermissionData(current => {
      let {requested = []} = current;
      if (!Array.isArray(requested)) {
        requested = [];
      }
      //if we have already requested it, then no need to update our data.
      const toRequest = requestedPermissions.filter(haveWeAsked => {
        if (!haveWeAsked?.targetId || !haveWeAsked?.permission ) {
          return false;
        }
        return !requested?.find(alreadyAsked => {
          if (!alreadyAsked?.targetId)
            return false;

          return alreadyAsked?.targetId?.toString() === haveWeAsked?.targetId.toString()
           && alreadyAsked?.permission === haveWeAsked?.permission
        })
      });
      if (toRequest.length > 0) {
        loadPermissions(toRequest);
      }
      //deliberate no op with the permission data itself.
      //this is to remove the dependency on permission data when
      //evaluating what we want to load.
      return current;
    })



  },[service]);

  const getCurrentPosition = useCallback(async (programId) => {
    return await service.getCurrentPosition(programId);
  },[service]);

  const requestPermissionsForNavigation = useCallback((navigation) => {
    const programId = getProgramId(navigation);

    requestPermissions(programId,[{
      permission:"CanEditProgramSupplemental",
      targetId:programId
    },
    {
      permission:"CanViewProgramSupplemental",
      targetId:programId
    },
    {
      permission:"CanViewProgramReports",
      targetId:programId
    }
    ]);

  },[requestPermissions])

  return {
    permissions:permissionData.verified,
    requestPermissions,
    requestPermissionsForNavigation,
    clear,
    getCurrentPosition
  }
}

export default usePermissions;